import {
    getQueryString,
    UA,
} from '@src/lib/utils/tools';
// import __INSTANCE__ from '../InstanceManager';
const handleUa = (list: any) => {
    const ua = window.navigator.userAgent;
    const result: {[key: string]: boolean} = {};
    Object.keys(list).forEach((key: any) => {
        result[key] = !!ua.match(list[key]);
    });
    return result;
};
export const envConfList = {
    browser: {
        safari: /^((?!chrome|android).)*safari/i, // safari浏览器
        UC: /UCBrowser/i, // UC浏览器
        QQBrowser: /MQQBrowser/i, // QQ浏览器
        hi: /baiduhi/i, // 百度hi
        huaweiBrowser: /\(.*Android.*(HUAWEI|HONOR|HW-|H60-).*\)|^HONOR|^HUAWEI/i, // 华为浏览器
        weixin: /micromessenger/i,
        oppoBrowser: /oppobrowser|heytapbrowser/i, // oppo浏览器
        vivoBrowser: /VivoBrowser/i, // vivo浏览器

    },
    os: {
        ios: /iphone|ipod|ipad/i,
        android: /android/i,
    },
    bdMatrixList: {
        newapp: /newapp/i, // 文心一言
    },
};
// 端外浏览器
const browser = handleUa(envConfList.browser);
// 系统
const os = handleUa(envConfList.os);
// 厂内APP
const bdMatrixList = handleUa(envConfList.bdMatrixList);

const isInNewApp = bdMatrixList.newapp;

const browserName = Object.keys(browser).find(item => browser[item] === true) || 'other';

// 获取ios系统版本
const getIOSVersion = () => {
    try {
        const ua = window.navigator.userAgent;
        const match = /OS (\d+)_(\d+)_(\d+)/.exec(ua);
        if (match) {
            return parseFloat(match[1] + '.' + match[2] + '.' + match[3]);
        }
        // 如果没有找到匹配项，则返回null
        return null;
    }
    catch {
        return null;
    }
};

const compareIOSVersion = (version: number) => {
    const iosVersion = getIOSVersion();
    if (iosVersion) {
        return iosVersion > version;
    }
    // 若未获取到版本信息，默认为true
    return true;
};

// 判断是否为pc客户端
const isPcClient = () => {
    // warning: 不能使用__INSTANCE__， 存在极深的循环引用问题
    const platform = getQueryString('platform') || '';
    return platform === 'pc_client' || UA.includes('newapp_pc_client');
};

export {
    bdMatrixList,
    browser,
    browserName,
    compareIOSVersion,
    isInNewApp,
    isPcClient,
    os,
};
